import React, { useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { useToast } from '~/lib/ui/toast'
import { cn } from '~/lib/utils'

const Dropzone = ({ selectedFiles, setSelectedFiles, className, children }) => {
  const [isDraggingOver, setIsDraggingOver] = useState(false)
  const { toast } = useToast()

  const onDropAccepted = (incomingFiles) => {
    setSelectedFiles([...selectedFiles, ...incomingFiles])
  }

  const onDropRejected = (incomingFiles) => {
    const {
      file: { type },
      errors,
    } = incomingFiles[0]
    const description = errors.map((e) => ` • ${e.message}`).join('\n')
    console.error('File upload rejected:', description)
    if (type) {
      toast({
        description,
        title: 'File attachment failed',
        variant: 'destructive',
        duration: 10_000,
      })
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 5,
    accept: {
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        ['.docx'],
    },
    onDropAccepted,
    onDropRejected,
    onDragEnter: () => setIsDraggingOver(true),
    onDragLeave: () => setIsDraggingOver(false),
    onDrop: () => setIsDraggingOver(false),
    maxSize: 15_000_000, // 15MB
  })

  const baseRootClassName = cn(
    'min-h-[10rem] p-4 border-black/50 rounded-lg border-dashed border-2 text-center content-center justify-items-center cursor-pointer',
    className,
  )
  const rootClassName = isDraggingOver
    ? cn(baseRootClassName, 'border-primary bg-lily-blue')
    : baseRootClassName

  return (
    <div className="pb-4">
      <div className="mb-2 flex flex-row items-center justify-start">
        <div className="text-lg font-medium">File Attachments</div>
      </div>
      <div
        {...getRootProps({
          className: rootClassName,
        })}
      >
        <input {...getInputProps()} />
        <div>
          {children}
          <em>(Files must be in .pdf, .doc, or .docx format)</em>
        </div>
      </div>
    </div>
  )
}
export default Dropzone
